import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { SettingModelSettingType } from 'api/models';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SupportingConstructionClampSettings = () => {
    const { t } = useTranslation();
    const { selectedSettingType, enabled, setEnabled } = usePlacementStore(
        useShallow((state) => ({
            selectedSettingType: state.selectedSettingType,
            enabled: state.autoPlaceSupportingConstructionClamps,
            setEnabled: state.setAutoPlaceSupportingConstructionClamps
        }))
    );

    if (selectedSettingType !== SettingModelSettingType.Anchors) {
        return null;
    }

    return (
        <div className="rounded-sm border border-border-ultra-light bg-background-gray-ultra-light p-2">
            <Checkbox
                checked={enabled}
                label={t('labelAutoPlaceSupportingConstructionClamps')}
                onChange={(event) => setEnabled(event.currentTarget.checked)}
            />
        </div>
    );
};
